import React, { useCallback } from 'react';
import classnames from 'classnames';
import { getCommentBoxId } from '../../helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import s from './ThreadPostbox.scss';
const ThreadPostbox = ({ commentableItemId, commentableTypeId, position, parentComment, canPostComment, onThreadUpdated, onPublishSuccess, streamId, className, isSmall })=>{
    const handleThreadUpdated = useCallback((result)=>{
        onThreadUpdated && onThreadUpdated(streamId, result);
        onPublishSuccess && onPublishSuccess(result);
    }, [
        onThreadUpdated,
        streamId,
        onPublishSuccess
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['commentbox-wrapper'], position === 'topmost' && s['commentbox-wrapper-topmost'], position === 'bottom' && s['commentbox-wrapper-bottom'], className)
    }, /*#__PURE__*/ React.createElement(CommentBox, {
        id: getCommentBoxId(commentableTypeId, commentableItemId, position),
        className: s['commentbox'],
        commentableType: commentableTypeId,
        commentableItemId: commentableItemId,
        replyComment: parentComment,
        onPublishSuccess: handleThreadUpdated,
        canPostComment: !!canPostComment,
        isSmall: isSmall
    }));
};
ThreadPostbox.displayName = 'ThreadPostbox';
export default ThreadPostbox;

//# sourceMappingURL=ThreadPostbox.js.map